class EnhancedStickyMenu {
    constructor() {
        this.body = document.querySelector("body");
        this.header = document.querySelector("header");
        this.logo = document.querySelector("img.custom-logo");

        this.init();
    }

    init() {
        if (
            this.body.classList.contains('page-template-text')
            || this.body.classList.contains('page-template-wide')
        ) {
            this.header.classList.add("header__always-dark");
            this.showDarkLogo();
        }

        window.addEventListener("scroll", () => this.changeHeader());
    }

    changeHeader() {
        this.scrollPos = window.scrollY;

        if (this.scrollPos > 200) {
            this.header.classList.add("header__sticky");
            this.showDarkLogo();
        } else {
            this.header.classList.remove("header__sticky");
            this.showLightLogo();
        }
    }

    showDarkLogo() {
        const url = '/wp-content/uploads/2024/12/FABRIPALETStransparent.png';

        if ( ! this.logo.getAttribute('src').includes(url)) {
            this.logo.srcset = '';
            this.logo.src = url;
        }

        this.header.classList.remove("header__light");
        this.header.classList.add("header__dark");
    }

    showLightLogo() {
        if (this.header.classList.contains('header__always-dark')) return;

        const url = '/wp-content/uploads/2024/11/FABRIPALETSwhite.png';

        if ( ! this.logo.getAttribute('src').includes(url)) {
            this.logo.srcset = '';
            this.logo.src = url;
        }

        this.header.classList.remove("header__dark");
        this.header.classList.add("header__light");
    }
}

export default EnhancedStickyMenu;